import { createFileRoute } from '@tanstack/react-router';

import { ErrorLayout } from '@/components/ErrorLayout';

export const Route = createFileRoute('/error/503')({
  component: RouteComponent,
});

export function RouteComponent() {
  return (
    <ErrorLayout
      code="503"
      title="Service Indisponible"
      description="Le service est temporairement indisponible. Nous travaillons pour vous offrir le meilleur service possible."
      image="/assets/images/error-503.png"
      cta={{ label: "Retour à la page d'accueil", to: '/' }}
    />
  );
}
